import { render } from "./SelectionDetails.vue?vue&type=template&id=7a16719b"
const script = {}

import "./SelectionDetails.vue?vue&type=style&index=0&id=7a16719b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__